import { useSelector } from 'react-redux';
import { storeName } from '../redux/models/user.model';

const useRolePermissions: any = () => {
  const user = useSelector((state) => state[storeName].user);

  const hasPermission = (name: string) => {
    if (!user || !user.permissions || !user.permissions.length) {
      return false;
    }

    return user.permissions.includes(name);
  };

  const hasRole = (name: string) => {
    if (!user || !user.roles || !user.roles.length) {
      return false;
    }

    const lName = name.toLowerCase();
    return user.roles.some((role) => role.name.toLowerCase() === lName);
  };

  const hasAnyPermission = (...names: string[]) => {
    if (!user || !user.permissions || !user.permissions.length) {
      return false;
    }

    return names.some((name) => {
      return hasPermission(name);
    });
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasRole,
  };
};

export default useRolePermissions;
